import { WithKey } from '@app/utils/object-extensions/with-key';
import { StringKeys } from '@app/utils/string-keys';

/**
 * Returns a function which adds the property Key to a given element. The function returns a new
 * object (the given one is not mutated). The key is calculated based on the given properties.
 *
 * @param properties Properties of the object to be used to create the key.
 */
export function enhanceWithKey<T>(properties: Array<StringKeys<T>>) {
  return function (entry: T): T & WithKey {
    let key: string = '';

    for (const property of properties) {
      const value = entry[property];

      if (value != null) {
        key += value;
      }
    }

    return {
      ...entry,
      key,
    };
  };
}
